import Modal from 'modules/app-core/modal'
import NotesList from 'modules/notes/components/NotesList'

export default Modal.containers.Modal({
  content: {
    position: 'top',
    size: 'large',
    styles: {
      width: '100%',
      margin: '50px 0 0 0',
    },
  },
  overlay: {
    hideCloseButton: false,
    routeOnHide: false,
    dark: false,
    background: '#fff',
  },
})(NotesList)
